import { render, staticRenderFns } from "./CertificatesList.vue?vue&type=template&id=55fd9c33&"
import script from "./CertificatesList.vue?vue&type=script&lang=js&"
export * from "./CertificatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports